interface ServerTaxBreakdownDetails {
  name: string
  dynamic_tax: boolean
  sell: number
  sell_currency:string
  currency: string
  unit?: string
  duration_type?: string
  value?: number
  per_person?: boolean
}

export interface ServerTaxBreakdown {
  check_in: string
  check_out: string
  tax_breakdown: Array<ServerTaxBreakdownDetails>
}

export function taxBreakdownMap(taxBreakdownResponse: ServerTaxBreakdownDetails): App.TaxBreakdown {
  return ({
    name: taxBreakdownResponse.name,
    amount: taxBreakdownResponse.sell,
  })
}
